// extracted by mini-css-extract-plugin
export default {"loginForm":"SignInForm_loginForm__kQ2Vv","input":"SignInForm_input__L2-67","button":"SignInForm_button__wEiX9","signUpContainer":"SignInForm_signUpContainer__ZFlY-"};